class Errors {
    static attachGlobalErrorHandler() {
        window.addEventListener("error", e => {
            console.log(e);
            Errors.extractStackAndSend(e.error);
        });
        window.addEventListener("unhandledrejection", e => {
            console.log(e);
            if (typeof e.reason === "object") {
                Errors.extractStackAndSend(e.reason);
            }
        });
    }

    static extractStackAndSend(e) {
        if (!e) {
            return;
        }
        let message = "";
        let stack = "";

        if (typeof e.message === "string") {
            message = e.message;
        }
        if (typeof e.stack === "string") {
            stack = e.stack;
        }
        if (message && message.length > 0) {
            Logger.error(message, stack);
        }
    }
}
